import { render, staticRenderFns } from "./array-table-field-items.vue?vue&type=template&id=cc14ea2e&scoped=true"
import script from "./array-table-field-items.vue?vue&type=script&lang=js"
export * from "./array-table-field-items.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc14ea2e",
  null
  
)

export default component.exports